// scroll bar
import 'simplebar/dist/simplebar.min.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@mui/material-pigment-css/styles.css';
// contexts
//import { SettingsProvider } from './contexts/SettingsContext';
//import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';

//
import App from './App';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

const rootNode = document.getElementById('root');
if (rootNode !== null) {
  const reactRoot = ReactDOM.createRoot(rootNode);
  reactRoot.render(
    <>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </QueryClientProvider>
    </>
  );
}
